<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / {{ $t('menu.vehicleSegments') }}
        </div>
        <div class="va-card__header-actions">
          <va-button small icon="fa fa-plus" to="/segment/ekleme">{{ $t('tables.actions.create') }}</va-button>
        </div>
      </template>

      <div class="row align--center mt-1">
        <div class="flex xs12 md6">
          <va-input
            v-model="filter.name"
            :label="$t('tables.searchBy.name')"
          />
        </div>
        <div class="flex xs3 sm2 md1">
          <div class="btn--wrapper">
            <va-button small outline @click.stop="onfilter" icon="fa fa-search"/>
            <va-button v-show="hasFilter" small outline @click.stop="onclearfilter" icon="fa fa-eraser"/>
          </div>
        </div>
      </div>

      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('tables.actions.translate')} ` + (props.rowData.name.en ? `${$t('tables.actions.edit')}` : `${$t('tables.actions.add')}`)" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small :color="props.rowData.name.en ? 'info' : 'gray'" class="ma-0" @click.stop="buttonAsHref('/segment/'+props.rowData.id+'/ceviri')">
              {{ $t('tables.actions.english') }}
            </va-button>
          </va-popover>
          <va-popover :message="`${$t('tables.actions.edit')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="info" icon="fa fa-pencil" @click.stop="buttonAsHref('/segment/'+props.rowData.id+'/duzenleme')"/>
          </va-popover>
          <va-popover :message="`${$t('tables.actions.destroy')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="warning" icon="fa fa-trash"  @click.stop="confirmDeleteVehicleSegment(props.rowData)"/>
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import vehicleSegmentServices from '../../../services/api/vehicleSegment'
import responseMixin from '../../../services/api/response'
import helperMixin from '../../../services/helper'
export default {
  mixins: [responseMixin, helperMixin],
  data () {
    return {
      isMobile: false,
      loading: false,
      items: [],
      filter: {
        name: null
      },
      hasFilter: false,
      showConfirmationModal: false
    }
  },
  computed: {
    fields () {
      return [{
        name: 'name_readable',
        title: this.$t('tables.headings.segment.name'),
        width: '30%',
      }, {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    }
  },
  watch: {
    '$route.query'(val) {
      this.splitQuery(val);
    }
  },
  methods: {
    async getVehicleSegments(filter = {}){
      this.loading = true;
      this.hasFilter = !!this.filter.name;

      filter.sort = '-id';
      
      const result = await vehicleSegmentServices.get('', {
          params: filter
        });
      if(result.error){
        this.items = [];
        return ;
      }
      this.loading = false;
      this.items = result.data.data;
    },
    async deleteVehicleSegment(id) {
      const res = await vehicleSegmentServices.delete(id);
      if(res.error){
        this.responseToast('DELETE', 'error', res);
        return ;
      }
      this.responseToast('DELETE', 'success');
      this.getVehicleSegments();
    },
    confirmDeleteVehicleSegment(item) {
      this.$dialog
        .confirm( item.name_readable + ' isimli segmenti silmek üzeresiniz, onaylıyor musunuz?', {
          loader: true,
          okText: "Sil",
          cancelText: "Vazgeç"
        })
        .then(dialog => {
          this.deleteVehicleSegment(item.id);
          dialog.close();
        })
        .catch(dialog => {
          dialog.close();
        });
    },
    onfilter () {
      let q = this.mergeQuery();
      this.$router.push({ path: '/segment/listesi', query: q });
      this.getVehicleSegments(JSON.parse(JSON.stringify(this.filter)));
    },
    onclearfilter () {
      this.$router.push({ path: '/segment/listesi' });
      this.filter = { name: null };
      this.getVehicleSegments(1, {});
    },
    mergeQuery() {
      let q = {};
      if(!!this.filter.name) {
        q.segment = this.filter.name!="" ? this.filter.name : null;
      } else {
        this.filter.name = this.filter.name!="" ? this.filter.name : null;
      }
      return q;
    },
    splitQuery(q) {
      if(q !== {}) {
        if(!!q.segment) {
          this.filter.name = q.segment;
        }
      }
      this.getVehicleSegments(JSON.parse(JSON.stringify(this.filter)));
    }
  },
  created() {
    this.isMobile = this.checkIsMobile();
    this.splitQuery(this.$route.query);
  }
}
</script>

<style lang="scss" scoped>
.btn--wrapper {
  position: relative;
  margin-top: -1rem;
}
</style>